'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import AamiLogo from './brands/aami';
import AanzLogo from './brands/aanz';
import ApiaLogo from './brands/apia';
import AustralianSeniorsLogo from './brands/australianSeniors';
import CotaLogo from './brands/cota';
import EdiLogo from './brands/edi';
import FoundationLogo from './brands/foundation';
import GuLogo from './brands/gu';
import ImanLogo from './brands/iman';
import IngLogo from './brands/ing';
import NibLogo, { NibArrow, NibLogomark, NibWordmark } from './brands/nib';
import NibThrive from './brands/nibThrive';
import NsiLogo from './brands/nsi';
import OrbitProtectLogo from './brands/orbitProtect';
import PricelineLogo from './brands/priceline';
import QantasLogo from './brands/qantas';
import RealLogo from './brands/real';
import SuncorpLogo from './brands/suncorp';
import TidLogo from './brands/tid';
import WorldNomadsLogo from './brands/worldNomads';
// eslint-disable-next-line @typescript-eslint/ban-types
const Logo = props => {
  const themeContext = useContext(ThemeContext);
  const {
    innerRef,
    size = 'small',
    invert = false,
    ...otherProps
  } = props;
  const logoProps = {
    ...otherProps,
    'data-mesh-component': 'LOGO'
  };
  // We use the theme selector to look at which brand the theme is using and then render the appropriate logo from that.
  // No need to manually pass in a prop :)
  switch (themeContext.id) {
    case 'ing':
      return /*#__PURE__*/_jsx(IngLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'qantas':
      return /*#__PURE__*/_jsx(QantasLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'gu':
      return /*#__PURE__*/_jsx(GuLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'suncorp':
      return /*#__PURE__*/_jsx(SuncorpLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'apia':
      return /*#__PURE__*/_jsx(ApiaLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'aami':
      return /*#__PURE__*/_jsx(AamiLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'nsi':
      return /*#__PURE__*/_jsx(NsiLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'cota':
      return /*#__PURE__*/_jsx(CotaLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'iman':
      return /*#__PURE__*/_jsx(ImanLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'foundation':
      return /*#__PURE__*/_jsx(FoundationLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'priceline':
      return /*#__PURE__*/_jsx(PricelineLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'worldNomads':
      return /*#__PURE__*/_jsx(WorldNomadsLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'australianSeniors':
      return /*#__PURE__*/_jsx(AustralianSeniorsLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'real':
      return /*#__PURE__*/_jsx(RealLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'aanz':
      return /*#__PURE__*/_jsx(AanzLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'edi':
      return /*#__PURE__*/_jsx(EdiLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'tid':
      return /*#__PURE__*/_jsx(TidLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'orbitProtect':
      return /*#__PURE__*/_jsx(OrbitProtectLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
    case 'nib':
    default:
      return /*#__PURE__*/_jsx(NibLogo, {
        size: size,
        invert: invert,
        ...logoProps
      });
  }
};
Logo.displayName = 'Logo';
export { AanzLogo, ApiaLogo, AustralianSeniorsLogo, CotaLogo, EdiLogo, FoundationLogo, GuLogo, ImanLogo, NibArrow, NibLogo, NibLogomark, NibThrive, NibWordmark, NsiLogo, PricelineLogo, QantasLogo, RealLogo, SuncorpLogo, WorldNomadsLogo };
export default Logo;